import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getBlogs } from '../lib/api';

const BASE   = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';
const imgSrc = (url) => !url?null:url.startsWith('http')?url:`${BASE}${url}`;

export default function BlogsPage() {
  const [blogs,   setBlogs]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlogs().then(setBlogs).catch(()=>setBlogs([])).finally(()=>setLoading(false));
  }, []);

  return (
    <div style={{ paddingTop:88, paddingBottom:80, paddingLeft:40, paddingRight:40, minHeight:'100vh' }}>
      <div style={{ maxWidth:1200, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:52 }}>
          <div style={{ fontSize:11, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--gold)', fontWeight:500, marginBottom:14 }}>The Journal</div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(36px,6vw,60px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em' }}>Style & Stories</h1>
        </div>

        {loading ? (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:28 }}>
            {Array.from({length:6}).map((_,i) => (
              <div key={i} className="animate-pulse">
                <div style={{ aspectRatio:'16/9', background:'var(--grey)', marginBottom:16 }} />
                <div style={{ height:12, background:'var(--grey)', width:'70%', marginBottom:8 }} />
                <div style={{ height:11, background:'var(--grey)', width:'50%' }} />
              </div>
            ))}
          </div>
        ) : blogs.length === 0 ? (
          <p style={{ textAlign:'center', color:'var(--grey-mid)', padding:'60px 0', fontSize:14 }}>No blog posts yet.</p>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:28 }}>
            {blogs.map(b => (
              <Link key={b.id} to={`/blogs/${b.slug}`} style={{ textDecoration:'none', color:'inherit', display:'flex', flexDirection:'column', border:'1px solid var(--grey)', background:'#fff', transition:'all 0.25s' }}
                onMouseEnter={e=>{ e.currentTarget.style.boxShadow='var(--shadow-md)'; e.currentTarget.style.transform='translateY(-2px)'; }}
                onMouseLeave={e=>{ e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none'; }}>
                <div style={{ aspectRatio:'16/9', background:'var(--cream)', overflow:'hidden' }}>
                  {b.cover_img
                    ? <img src={imgSrc(b.cover_img)} alt={b.title} style={{ width:'100%', height:'100%', objectFit:'cover', transition:'transform 0.5s ease' }}
                        onMouseEnter={e=>e.target.style.transform='scale(1.05)'}
                        onMouseLeave={e=>e.target.style.transform='scale(1)'} />
                    : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
                        <span style={{ fontSize:11, color:'var(--grey)', letterSpacing:'0.15em', textTransform:'uppercase' }}>Aurora Luxury</span>
                      </div>
                  }
                </div>
                <div style={{ padding:'20px 22px 24px', display:'flex', flexDirection:'column', gap:10, flex:1 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                    <span style={{ fontSize:10, letterSpacing:'0.18em', textTransform:'uppercase', color:'var(--gold)', fontWeight:600 }}>{b.category}</span>
                    <span style={{ color:'var(--grey)', fontSize:10 }}>·</span>
                    <span style={{ fontSize:11, color:'var(--grey-mid)' }}>{new Date(b.created_at).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</span>
                  </div>
                  <h2 style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:300, color:'var(--dark)', lineHeight:1.3 }}>{b.title}</h2>
                  {b.excerpt && <p style={{ fontSize:12, color:'var(--grey-dark)', lineHeight:1.7, flex:1 }}>{b.excerpt}</p>}
                  <div style={{ fontSize:11, color:'var(--gold)', fontWeight:600, letterSpacing:'0.1em', marginTop:8 }}>Read More →</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}